<mat-form-field appearance="outline" style="width:50vw">
    <mat-label>mm/yyyy</mat-label>
    <input
      matInput
      [matDatepicker]="picker"
      [formControl]="monthYearControl"
      (blur)="onInputBlur($event)"
      placeholder="MM/YYYY"
      monthYear
    />
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker
      #picker
      startView="multi-year"
      (yearSelected)="chosenYearHandler($event)"
      (monthSelected)="chosenMonthHandler($event, picker)"
      panelClass="month-year-picker">
    </mat-datepicker>
</mat-form-field>

<button mat-icon-button (click)="clear()" [disabled]="!monthYearControl.value || disabled">
    <mat-icon>clear</mat-icon>
</button>